import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

interface InitDatadogConfig {
  applicationId: string;
  clientToken: string;
  service: string;
  env: string;
}

const SITE = 'datadoghq.com';

export const initDatadog = ({ applicationId, clientToken, service, env }: InitDatadogConfig): void => {
  if (!applicationId || !clientToken || env === 'test') {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: SITE,
    service,
    env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask',
    plugins: [reactPlugin({ router: true })],
  });

  datadogLogs.init({
    clientToken,
    site: SITE,
    service,
    env,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['warn', 'error'],
    sessionSampleRate: 100,
  });
};
